import useBRRedesign from "../../../../hooks/features/useBRRedesign";
import useAltView from "../../../../hooks/features/useAltView";

const buildMainImage = (product, isBRRedesignEnabled) => {
  const { 
    zoomImages: {
      p01ZoomImagePath: zoomMain,
    } = {},
    url: main = "",
  } = product;
  return isBRRedesignEnabled && zoomMain ? zoomMain : main;
}

const buildAltViewImage = (product, isBRRedesignEnabled) => {
  const {
    zoomImages: {
      av1ZoomImagePath: zoomAltView,
    } = {},
    avImages: {
      av1QuicklookImagePath: altView = "",
    } = {},
  } = product;
  return isBRRedesignEnabled && zoomAltView ? zoomAltView : altView;
}

const useProductImagery = (product, cid) => {
  const isBRRedesignEnabled = useBRRedesign();
  const isAltViewEnabled = useAltView(cid);

  return {
    mainImageSrc: buildMainImage(product, isBRRedesignEnabled),
    hoverImageSrc: isAltViewEnabled ? buildAltViewImage(product, isBRRedesignEnabled) : undefined,
  }
}

export default useProductImagery;